import React from "react";
//#region src/components/Breadcrumbs/BreadcrumbsContext.tsx
var BreadcrumbsContext = React.createContext({
	appendBreadcrumbs: () => void 0,
	breadcrumbs: [],
	isCurrentLinkMatcher: void 0,
	onBack: void 0,
	onNavigate: () => void 0,
	resetBreadcrumbs: () => void 0,
	setBreadcrumbs: () => void 0
});
//#endregion
export { BreadcrumbsContext };

//# sourceMappingURL=BreadcrumbsContext.js.map